import { c as _c } from "react/compiler-runtime";
import CreateWaveOutcomeTypes from "./CreateWaveOutcomeTypes";
import CreateWaveOutcomesManual from "./manual/CreateWaveOutcomesManual";
import CreateWaveOutcomesRep from "./rep/CreateWaveOutcomesRep";
import CreateWaveOutcomesCIC from "./cic/CreateWaveOutcomesCIC";
import CreateWaveOutcomesRows from "./winners/rows/CreateWaveOutcomesRows";
import type { CreateWaveDatesConfig, CreateWaveOutcomeConfig } from "@/types/waves.types";
import { CreateWaveOutcomeType } from "@/types/waves.types";
import CommonAnimationHeight from "@/components/utils/animation/CommonAnimationHeight";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
import CreateWaveApprovalMaxWinners from "./CreateWaveApprovalMaxWinners";
import CreateWaveOutcomeWarning from "./CreateWaveOutcomeWarning";
import type { JSX } from "react";
export default function WavesOutcome(t0) {
  const $ = _c(45);
  const {
    outcomes,
    outcomeType,
    waveType,
    errors,
    dates,
    maxWinners,
    setOutcomeType,
    setOutcomes,
    setMaxWinners
  } = t0;
  const isApproveWave = waveType === ApiWaveType.Approve;
  let t1;
  if ($[0] !== outcomes || $[1] !== setOutcomeType || $[2] !== setOutcomes) {
    t1 = outcome => {
      setOutcomes([...outcomes, outcome]);
      setOutcomeType(null);
    };
    $[0] = outcomes;
    $[1] = setOutcomeType;
    $[2] = setOutcomes;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onOutcome = t1;
  let t2;
  if ($[4] !== setOutcomeType) {
    t2 = () => {
      setOutcomeType(null);
    };
    $[4] = setOutcomeType;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onCancel = t2;
  let t3;
  if ($[6] !== onCancel || $[7] !== onOutcome || $[8] !== waveType) {
    t3 = <CreateWaveOutcomesManual onOutcome={onOutcome} onCancel={onCancel} waveType={waveType} />;
    $[6] = onCancel;
    $[7] = onOutcome;
    $[8] = waveType;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== onCancel || $[11] !== onOutcome || $[12] !== waveType) {
    t4 = <CreateWaveOutcomesRep onOutcome={onOutcome} onCancel={onCancel} waveType={waveType} />;
    $[10] = onCancel;
    $[11] = onOutcome;
    $[12] = waveType;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== onCancel || $[15] !== onOutcome || $[16] !== waveType) {
    t5 = <CreateWaveOutcomesCIC onOutcome={onOutcome} onCancel={onCancel} waveType={waveType} />;
    $[14] = onCancel;
    $[15] = onOutcome;
    $[16] = waveType;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t5) {
    t6 = {
      [CreateWaveOutcomeType.MANUAL]: t3,
      [CreateWaveOutcomeType.REP]: t4,
      [CreateWaveOutcomeType.NIC]: t5
    };
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const components = t6;
  let t7;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="tw-mb-0 tw-text-xl tw-font-semibold tw-text-white">Choose outcome type</p>;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== dates || $[24] !== isApproveWave || $[25] !== maxWinners || $[26] !== setMaxWinners || $[27] !== waveType) {
    t8 = isApproveWave && <div className="tw-space-y-4"><CreateWaveApprovalMaxWinners maxWinners={maxWinners} setMaxWinners={setMaxWinners} /><CreateWaveOutcomeWarning waveType={waveType} dates={dates} maxWinners={maxWinners} /></div>;
    $[23] = dates;
    $[24] = isApproveWave;
    $[25] = maxWinners;
    $[26] = setMaxWinners;
    $[27] = waveType;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== outcomeType || $[30] !== setOutcomeType) {
    t9 = <CreateWaveOutcomeTypes outcomeType={outcomeType} setOutcomeType={setOutcomeType} />;
    $[29] = outcomeType;
    $[30] = setOutcomeType;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== components || $[33] !== errors || $[34] !== outcomeType || $[35] !== outcomes || $[36] !== setOutcomes || $[37] !== waveType) {
    t10 = outcomeType ? components[outcomeType] : <CreateWaveOutcomesRows waveType={waveType} errors={errors} outcomes={outcomes} setOutcomes={setOutcomes} />;
    $[32] = components;
    $[33] = errors;
    $[34] = outcomeType;
    $[35] = outcomes;
    $[36] = setOutcomes;
    $[37] = waveType;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== t10) {
    t11 = <div><CommonAnimationHeight>{t10}</CommonAnimationHeight></div>;
    $[39] = t10;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== t11 || $[42] !== t8 || $[43] !== t9) {
    t12 = <div className="tw-mx-auto tw-w-full">{t7}<div className="tw-mt-3 tw-space-y-6">{t8}{t9}{t11}</div></div>;
    $[41] = t11;
    $[42] = t8;
    $[43] = t9;
    $[44] = t12;
  } else {
    t12 = $[44];
  }
  return t12;
}